'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("directiveUtils", function ($compile, $animate) {
  var SNAKE_CASE_REGEXP = /[A-Z]/g;
  var directiveUtils = {
    /**
     * Compiles a directives and returns the link function.
     * This is an alias for 'myDirective' -> $compile($("<my-directive>"))
     *
     * @param directiveName The name of the directive to compile
     * @param [attributes] list of attributes to set on the directive element
     * @returns The link method for given directive.
     */
    compileDirective: function compileDirective(directiveName, attributes) {
      var element = $("<" + directiveUtils.toSnakeCase(directiveName) + ">");
      if (attributes) {
        element.attr(attributes);
      }
      return $compile(element);
    },
    /**
     * Converts a camelCase name to snake case. Useful when trying to compile a directive from it's angular name.
     * Example : "myCustomDirective" -> "my_custom_directive"
     * @param name The name to convert to snake case.
     * @param [separator='-'] will use given separator instead of "-" if provided
     */
    toSnakeCase: function toSnakeCase(name, separator) {
      separator = separator || '-';
      return name.replace(SNAKE_CASE_REGEXP, function (letter, pos) {
        return (pos ? separator : '') + letter.toLowerCase();
      });
    },
    /**
     * Retrieve given controller on nearest parent.
     * Useful when working with recursive / nested directives or controller
     * ( as require : "^controller" will first lookup on current element )
     *
     * @param $el The element to start search parents for (will NOT search controller on given element)
     * @param controllerName Name of the controller to retrive
     * @returns The parent controller or null if none found
     */
    getParentController: function getParentController($el, controllerName) {
      var current = $el,
        ctrl;
      while ((current = current.parent()).length) {
        /* jshint -W084 */
        if (ctrl = current.controller(controllerName)) {
          return ctrl;
        }
        /* jshint +W084 */
      }
      return null;
    },
    /**
     * Copy controllers from one element to another.
     * Used with multiple transclusion target
     * to copy root element controllers to transclusion targets.
     */
    copyControllers: function copyControllers(fromEl, toEl) {
      var controllersData = {};
      _.each(fromEl.data(), function (value, name) {
        if (/\$.*Controller$/.test(name)) {
          controllersData[name] = value;
        }
      });
      toEl.data(controllersData);
    },
    /**
     * Creates the watch change function for an ngIf like directive
     *
     * @param $element the transcluding directive element.
     * @param $transclude the pre-binded transclude form the directive's link fn.
     */
    createNgIfTranscludeWatchFn: function createNgIfTranscludeWatchFn($element, $transclude) {
      return function () {
        var childScope, element;
        return function (condition) {
          if (condition) {
            if (!childScope) {
              $transclude(function (clone, newScope) {
                childScope = newScope;
                element = clone;
                $animate.enter(clone, $element.parent(), $element);
              });
            }
          } else {
            if (element) {
              element.remove();
              element = null;
            }
            if (childScope) {
              childScope.$destroy();
              childScope = null;
            }
          }
        };
      }();
    }
  };
  return directiveUtils;
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/directiveUtils.js
// module id = 2751
// module chunks = 13